import styles from '../ExpressModeModal.module.css';

interface AspectRatioSelectorProps {
  value: '16:9' | '9:16';
  onChange: (ratio: '16:9' | '9:16') => void;
}

export function AspectRatioSelector({ value, onChange }: AspectRatioSelectorProps) {
  return (
    <div className={styles.aspectRatioSelector}>
      <button
        type="button"
        className={`${styles.aspectRatioButton} ${value === '16:9' ? styles.aspectRatioActive : ''}`}
        onClick={() => onChange('16:9')}
        title="横長 (16:9)"
      >
        <span className={styles.aspectRatioFrameLabel}>横型</span>
        <svg width="28" height="18" viewBox="0 0 28 18" fill="none">
          <rect x="1" y="1" width="26" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        </svg>
        <span>16:9</span>
      </button>
      <button
        type="button"
        className={`${styles.aspectRatioButton} ${value === '9:16' ? styles.aspectRatioActive : ''}`}
        onClick={() => onChange('9:16')}
        title="縦長 (9:16)"
      >
        <span className={styles.aspectRatioFrameLabel}>縦型</span>
        <svg width="18" height="28" viewBox="0 0 18 28" fill="none">
          <rect x="1" y="1" width="16" height="26" rx="2" stroke="currentColor" strokeWidth="1.5" />
        </svg>
        <span>9:16</span>
      </button>
    </div>
  );
}
